import type { ReceiptTemplate } from '../schema';

export const daysInnTemplate: ReceiptTemplate = {
  id: 'days-inn',
  name: 'Days Inn Receipt',
  brand: 'DAYS INN',
  description: 'Days Inn hotel receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'di-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'DAYS INN',
        businessNameFontSize: 20,
        addressLines: ['BY WYNDHAM', '1200 DARK AVENUE', 'MONSTERVILLE, CA 94608', '(510) 555-0127'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'di-guest',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'guest', label: 'Guest:', value: 'JOHN DOE' },
          { id: 'room', label: 'Room:', value: '215' },
        ],
        column2: [
          { id: 'in', label: 'Check-In:', value: '01/02/2026' },
          { id: 'out', label: 'Check-Out:', value: '01/04/2026' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'di-charges',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'room', label: 'ROOM (2 NIGHTS)', value: '138.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX (12%)', value: '16.56', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '154.56', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'di-payment',
      type: 'payment',
      enabled: true,
      config: { alignment: 'left', method: 'VISA ****4144', fields: [], showDivider: true, dividerStyle: 'dashed' },
    },
    {
      id: 'di-footer',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'WYNDHAM REWARDS MEMBER\n\nTHANK YOU FOR STAYING', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

